// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XNUwz","requiredAsterisk":"Info_requiredAsterisk__2P_ny"};